var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1266 6.10019C20.2913 2.34811 25.7066 2.34811 27.8712 6.10019L41.6606 30.0018C43.824 33.7518 41.1176 38.4377 36.7883 38.4377H9.20956C4.88023 38.4377 2.1738 33.7518 4.33726 30.0018L18.1266 6.10019ZM22.9993 15.9376C23.776 15.9376 24.4056 16.5672 24.4056 17.3438V24.3751C24.4056 25.1517 23.776 25.7813 22.9993 25.7813C22.2227 25.7813 21.5931 25.1517 21.5931 24.3751V17.3438C21.5931 16.5672 22.2227 15.9376 22.9993 15.9376ZM22.9993 31.4063C23.776 31.4063 24.4056 30.7767 24.4056 30.0001C24.4056 29.2234 23.776 28.5938 22.9993 28.5938C22.2227 28.5938 21.5931 29.2234 21.5931 30.0001C21.5931 30.7767 22.2227 31.4063 22.9993 31.4063Z",
    fill: "#FB3C3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.3a17e3ea12bd594152e37c1af826c428.svg";
export { ForwardRef as ReactComponent };